// src/fontAwesome.ts
import {library} from "@fortawesome/fontawesome-svg-core";
import {faPhone} from "@fortawesome/free-solid-svg-icons";
import {
  faInstagram,
  faXTwitter,
  faLinkedinIn,
  faFacebookF,
} from "@fortawesome/free-brands-svg-icons";

// Add icons to the library
library.add(faPhone, faInstagram, faXTwitter, faLinkedinIn, faFacebookF);
